import { Button } from '@chegg-wt/core/components/SourceSearchBar/styled'
import { colors } from '@chegg-ui/theme'
import { fanta, TextInput } from '@chegg/fanta'
import styled, { css } from 'styled-components'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const SearchButton = styled(Button)<{ hasError: boolean }>`
  font-size: ${fanta.font.size.md};
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  &&& {
    padding: 0 40px;
  }
  background-color: ${colors.cheggOrange};
  &:hover {
    background-color: ${colors.orangeDark};
  }
  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    border-radius: 0 8px 8px 0;

    ${({ hasError }) =>
      hasError &&
      css`
        margin-bottom: 19px; /* re-center the button with input as the error div causes input container to grow */
      `}
  }
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    width: 100%;
    max-width: 100%;
    border-radius: 8px;
  }
`

export const SearchForm = styled.form`
  display: flex;
  flex-grow: 1;
  align-items: flex-end;

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
    width: 100%;

    > div > div > input {
      border-radius: 8px;
      margin-bottom: ${fanta.spacing.xs};
    }
  }
`

export const InputContainer = styled.div`
  width: 100%;
`

// fixes a11y color contrast issue present in Fanta
// will be fixed in upgrade to chegg-ui in https://chegg.atlassian.net/browse/WTP-1788
export const SearchInput = styled(TextInput)`
  ${({ error }) =>
    error &&
    css`
      border-color: ${colors.errorRed};
      & + [role='alert'] {
        color: ${colors.errorRed};
        @media screen and (max-width: 1068px) {
          margin-bottom: 0.4375rem;
        }
      }
    `}
  &:active {
    border-color: ${({ theme }) => theme.Colors.primaryColor};
  }
  &:focus {
    border-color: ${({ theme }) => theme.Colors.primaryColor};
  }
`
